import React from "react";
import Style from "./SimpleLayout.scss";

const SimpleLayout: React.FC = ({ children }) => {
    return (
        <div className={Style.Container}>
            <div className={Style.ContentWrapper}>{children}</div>
        </div>
    );
};

export default SimpleLayout;
